import React from "react";
import { useMutation, useQuery, useQueryClient } from "react-query";
import ApiRequest from "../../../../api/ApiRequest";
import { API_AUTH_TYPES, API_ROUTES } from "../../../../api/apiConstants";
import { useParams } from "react-router-dom";
import Toggle from "../../../../components/toggle";
import { InformationCircleIcon } from "@heroicons/react/outline";
import { ToolTipHoverContainer, ToolTipLeft } from "../../../../components/ToolTips";

const AnnualChecklistToggle = () => {
    const { household_id: householdId } = useParams();
    const householdsApi = new ApiRequest(
        API_ROUTES.HOUSEHOLDS,
        API_AUTH_TYPES.ADVISOR
    );

    const { data, isLoading } = useQuery({
        queryFn: householdsApi.getFn({
            endpoint: "settings",
            params: [householdId],
        }),
        queryKey: `household-settings-${householdId}`,
    });

    const queryClient = useQueryClient();

    const mutation = useMutation(
        (enabled) =>
            householdsApi.patch({
                endpoint: "settings",
                params: [householdId],
                body: { annual_checklist_enabled: enabled },
            }),
        {
            onSuccess: (data) => {
                queryClient.invalidateQueries(`household-settings-${householdId}`);
                queryClient.setQueryData(`household-settings-${householdId}`, {
                    annual_checklist_enabled: data.annual_checklist_enabled,
                });
            },
        }
    );

    if (isLoading) {
        return (
            <div className="flex items-center space-x-2 justify-between animate-pulse">
                <div className="h-4 w-32 bg-gray-200 rounded"></div>
                <div className="h-6 w-12 bg-gray-200 rounded"></div>
            </div>
        );
    }

    return (
        <div className="space-y-2">
            <div className="flex items-center space-x-2 justify-between">
                <div className="flex items-center space-x-2">
                    <label htmlFor="annual-checklist-toggle" className="text-gray-600">
                        Enabled for Client
                    </label>
                    <ToolTipHoverContainer>
                        <InformationCircleIcon className="h-5 w-5 text-gray-400 cursor-help" />
                        <ToolTipLeft>
                            When enabled, the Annual Checklist will be visible to the client, and the client will be able to mark items as completed.
                        </ToolTipLeft>
                    </ToolTipHoverContainer>
                </div>
                <Toggle
                    enabled={data?.annual_checklist_enabled}
                    setEnabled={() => mutation.mutate(!data?.annual_checklist_enabled)}
                    disabled={mutation.isLoading}
                />
            </div>

            {mutation.isError && (
                <p className="text-sm text-red-600">
                    Failed to update settings. Please try again.
                </p>
            )}
        </div>
    );
};

export default AnnualChecklistToggle; 